<div class="flex items-center gap-2">
  <h3 class="mr-auto">{{ title }}</h3>
  <button (click)="goToPreviousMonth()" class="btn btn-neutral-outline !py-1 !px-2" type="button" aria-label="Mes anterior">
    <img alt="Anterior" class="h-4" src="/assets/icons/feather/chevron-left.svg">
  </button>
  <h6 class="uppercase tracking-wide min-w-[9rem] text-center">{{ currentMonthLabel }}</h6>
  <button (click)="goToNextMonth()" class="btn btn-neutral-outline !py-1 !px-2" type="button" aria-label="Mes siguiente">
    <img alt="Siguiente" class="h-4" src="/assets/icons/feather/chevron-right.svg">
  </button>
</div>

<div class="flex flex-wrap w-full calendar-widget">
  @for (header of weekdayNames; track header) {
    <div class="calendar-header">
      <h6 class="inactive capitalize truncate" style="color: var(--color-neutral-400)">{{ header }}</h6>
    </div>
  }
  @for (day of calendarDays; track day.format("YYYY-MM-DD")) {
    <div [class.inactive]="!day.isSame(calendarDate, 'month')"
         class="calendar-item flex flex-col xl:flex-row gap-1">
      <h6 class="calendar-day font-semibold">{{ day.format('DD') }}</h6>
      <div class="flex flex-col gap-1 pr-4 w-full">
        @for (task of getTasksForDay(day); track task.id) {
          <div class="calendar-task" [title]="task.name">
            <span class="priority-dot" [ngClass]="getPriorityDotClass(task.priority)"></span>
            <span class="truncate">{{ task.name }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
